export default (httpClient) => ({
  save: async ({ nome, status, telefone, cpf, senha, admin, token }) => {
    const headers = {
      Authorization: "Bearer " + token,
      Accept: "application/json",
    };
    const response = await httpClient.post(
      "/colaboradores",
      { nome, telefone, status, cpf, admin, senha },
      { headers }
    );
    return {
      data: response.data,
    };
  },
  update: async ({ id, nome, status, telefone, cpf, admin, senha, token }) => {
    const headers = {
      Authorization: "Bearer " + token,
      Accept: "application/json",
    };
    const response = await httpClient.put(
      "/colaboradores/" + id,
      { nome, status, telefone, cpf, admin, senha },
      { headers }
    );
    return {
      data: response.data,
    };
  },
  getById: async ({ id, token }) => {
    const headers = {
      Authorization: "Bearer " + token,
      Accept: "application/json",
    };
    const response = await httpClient.get("/colaboradores/" + id, { headers });
    return {
      data: response.data,
    };
  },
  getAll: async ({ token }) => {
    const headers = {
      Authorization: "Bearer " + token,
      Accept: "application/json",
    };
    const response = await httpClient.get("/colaboradores", { headers });
    return {
      data: response.data,
    };
  },

  getPorTipo: async ({ token, tipo }) => {
    const headers = {
      Authorization: "Bearer " + token,
      Accept: "application/json",
    };
    const response = await httpClient.get("/marcas/" + tipo, { headers });
    return {
      data: response.data,
    };
  },

  delete: async ({ id, token }) => {
    const headers = {
      Authorization: "Bearer " + token,
      Accept: "application/json",
    };
    const response = await httpClient.delete("/colaboradores/" + id, {
      headers,
    });
    return {
      data: response,
    };
  },
  getCode: async ({ token, cliente_id }) => {
    let headers = {
      Authorization: "Bearer " + token,
    };
    const response = await httpClient.get("/buscar-code/" + cliente_id, {
      headers,
    });
    return {
      data: response.data,
    };
  },

  fazerAutenticacao: async ({ token, cliente_id }) => {
    let headers = {
      Authorization: "Bearer " + token,
    };
    const response = await httpClient.get(
      "/salvar-dados-gerar-token/" + cliente_id,
      { headers }
    );
    return {
      data: response.data,
    };
  },

  salvarCode: async ({ empresa_id, code, token }) => {
    const response = await httpClient.post(
      "/salvar-code/" + empresa_id,
      { code },
      { headers: { Authorization: "Bearer " + token } }
    );
    return {
      data: response.data,
    };
  },

  login: async ({ login, password }) => {
    const response = await httpClient.post("/login", {
      login,
      password,
    });
    return {
      data: response.data,
    };
  },
  verificaTokenColaborador: async (cliente_token) => {
    console.log("Arquivo cliente.js" + cliente_token);
    let headers = {
      Authorization: "Bearer " + cliente_token,
    };
    const response = await httpClient.get("/verifica-token-colaborador", {
      headers,
    });

    let errors = null;

    if (!response.data) {
      errors = {
        status: response.request.status,
        statusText: response.request.statusText,
      };
    }
    return {
      data: response.data,
      errors,
    };
  },
});
